import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { AboutHeader, AboutMission, AboutVision, AboutValues } from "@/components/about/AboutSections";
import { AboutServices } from "@/components/about/AboutServices";
import { AboutPhilosophy, AboutPresence } from "@/components/about/AboutPresence";

export default function About() {
  const { t } = useI18n();
  const a = t.about;
  return (
    <>
      <AboutHeader kicker={a.kicker} title={a.title} />
      <AboutMission t={t} a={a} />
      <AboutVision a={a} />
      <AboutValues a={a} />
      <AboutServices s={t.services} />
      <AboutPhilosophy a={a} />
      <AboutPresence a={a} />
    </>
  );
}
